import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingImageToDrawingConfig } from '@/data/landingConfig/landingImageToDrawingConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_ImageToDrawing } from './schemaObject';

interface Props {}
const ImageToDrawing: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_ImageToDrawing} />
			<LandingTemplate
				data={landingImageToDrawingConfig}
				funnelLinkService={GenerateLandingLinkService.funnelCartoonGenerator()}
			/>
		</>
	);
};

export default ImageToDrawing;
